import { createAsyncThunk } from "@reduxjs/toolkit";
import apiConfig from "constants/apiConfig";
import { fetchAllCollaborations, fetchCollaboration as fetchCollaborationAPI, fetchCollaborations as fetchCollaborationsAPI } from "services/api/campaign/collaboration";
import { AuthState } from "slices/auth/reducer";
import { ERROR } from "types";
import { Collaboration, CollaborationItem, Collaborations, CollaborationsSlice, GigStep, Milestone } from "types/campaign/collaborations";
import { generateUniqueKey, getErrorMessage, isFresh } from "utils/helpers";

// export const fetchCollaborations1 = createAsyncThunk<{ page: number, campaignId: string, collaborations: Collaborations }, { page: number, campaignId: string, force?: boolean }, { rejectValue: string }>(
//     'campaign/collaborations',
//     async ({ page, campaignId, force }, { getState, rejectWithValue }) => {
//         try {
//             const state = getState() as { auth: AuthState, collaborations: CollaborationsSlice };
//             const STALE_TIME = apiConfig.FETCH_CAMPAIGN_COLLABORATIONS.staleTime;
//             if (page === 1 && !force && isFresh(state.collaborations.campaigns[campaignId]?.last_fetched_at ?? null, STALE_TIME)) {
//                 return rejectWithValue(ERROR.CACHED);
//             }

//             const agencyId = state.auth.selectedAgencyId ?? '';

//             const collaborations = await fetchCollaborationsAPI(agencyId, campaignId, { page, sort: 'reach_count' });

//             return { campaignId, collaborations, page };

//         } catch (error) {
//             return rejectWithValue(getErrorMessage(error, "Failed to fetch collaborations!"));
//         }
//     }
// )

export const fetchCollaborations = createAsyncThunk<{collaborations: Collaborations, filters: {page: number, [key: string]: any}, filterId: string, campaignId: string}, {campaignId: string, force?: boolean, filters: {page: number, [key: string]: any}}, {rejectValue: string}>(
    'campaign/collaborations',
    async ({campaignId, force, filters}, { getState, rejectWithValue }) => {
        try {
            const STALE_TIME = apiConfig.FETCH_CAMPAIGN_COLLABORATIONS.staleTime;
            const filterId = generateUniqueKey(filters, ['page']);
            const state = getState() as {auth: AuthState, collaborations: CollaborationsSlice};
            if(filters.page === 1 && !force && isFresh(state.collaborations.campaigns[campaignId]?.filtered_lists?.[filterId]?.last_fetched_at ?? null, STALE_TIME)){
                return rejectWithValue(ERROR.CACHED);
            }
            const agencyId = state.auth.selectedAgency?.uuid ?? '';
            const collaborations = await fetchCollaborationsAPI(agencyId, campaignId, filters);
            return {collaborations, filters, filterId, campaignId};
        } catch (error) {
            return rejectWithValue('Failed to fetch campaign applications');
        }
    }
)

export const fetchCollaboration = createAsyncThunk<{ campaignId: string, collaborationId: string, collaboration: Collaboration, milestones: Milestone[], chat: {uuid: string} | null }, { collaborationId: string, campaignId: string, force?: boolean }, { rejectValue: string }>(
    'campaign/collaboration',
    async ({ collaborationId, campaignId, force }, { getState, rejectWithValue }) => {
        try {
            const state = getState() as { auth: AuthState, collaborations: CollaborationsSlice };
            const STALE_TIME = apiConfig.FETCH_CAMPAIGN_COLLABORATION.staleTime;
            if (!force && isFresh(state.collaborations.campaigns[campaignId]?.collaborations?.[collaborationId]?.last_fetched_at ?? null, STALE_TIME)) {
                return rejectWithValue(ERROR.CACHED);
            }

            const agencyId = state.auth.selectedAgencyId ?? '';

            const {collaboration, milestones, chat} = await fetchCollaborationAPI(agencyId, campaignId, collaborationId);

            return { campaignId, collaboration, collaborationId, milestones, chat };

        } catch (error) {
            return rejectWithValue(getErrorMessage(error, "Failed to fetch collaboration!"));
        }
    }
)

export const fetchAllCollaborationsThunk = createAsyncThunk<{count: number, items: CollaborationItem[], gig_steps: GigStep[], filters: { page: number, [key: string]: any }, filterId: string}, {filters: { page: number, [key: string]: any }, force?: boolean}, {rejectValue: string}>(
    'collaborations',
    async({filters, force}, {getState, rejectWithValue}) => {
        try {
            const state = getState() as { auth: AuthState, collaborations: CollaborationsSlice };
            const filterId = generateUniqueKey(filters, ['page']);
            const STALE_TIME = apiConfig.FETCH_CAMPAIGN_COLLABORATION.staleTime;

            if(filters.page === 1 && !force && isFresh(state.collaborations.collaborations?.filtered_lists?.[filterId]?.last_fetched_at, STALE_TIME)){
                return rejectWithValue(ERROR.CACHED);
            }

            const agencyId = state.auth.selectedAgencyId;
            if(!agencyId) throw new Error("No agency Selected!");

            const {count, items, gig_steps} = await fetchAllCollaborations(agencyId, {...filters, limit: 24});

            return {count, items, filters, filterId, gig_steps}

        } catch (error) {
            return rejectWithValue(getErrorMessage(error, "Failed to fetch collaboration!"));
        }
    }
)